import PropTypes from "prop-types";
import React from "react";
import BodyText from "../../elements/body-text";
import PrimaryLink from "../../elements/primary-link";
import "./style.scss";

const ServerError = ({ heading, subheading, infoMessage, showIcon, linkRetry, linkAway }) => {
  return (
    <div className="server-error">
      <h4 className="server-error__overline">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15V13H11V15H9ZM9 5V11H11V5H9Z" fill="#FF0000" />
        </svg>
        {heading}
      </h4>
      <h3 className="server-error__title">{subheading}</h3>
      <div className="server-error__info">
        <BodyText {...infoMessage} />
      </div>
      {showIcon && <div className="server-error__icon" />}
      {linkRetry?.buttonText && <PrimaryLink {...linkRetry} />}
      {linkAway && <PrimaryLink {...{ ...linkAway, iconName: null }} />}
    </div>
  );
};

ServerError.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  infoMessage: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
  linkRetry: PropTypes.object,
  linkAway: PropTypes.object
};

export default ServerError;
